import { Breadcrumb } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import { Link, useLocation } from 'react-router-dom'
import { useMemo } from 'react'
import { MODULES } from '@/shared/data/modules'

export function PageBreadcrumb() {
  const location = useLocation()

  const items = useMemo(() => {
    const segments = location.pathname.split('/').filter(Boolean)
    const result: { title: React.ReactNode; key: string }[] = [
      {
        key: 'home',
        title: (
          <Link to="/dashboard" className="!text-[var(--color-text-secondary)]">
            <HomeOutlined /> Trang chủ
          </Link>
        ),
      },
    ]

    if (segments.length === 0 || segments[0] === 'dashboard') return result

    const moduleKey = segments[0]
    const moduleDef = MODULES.find((m) => m.key === moduleKey)
    if (moduleDef) {
      result.push({
        key: moduleKey,
        title: (
          <Link to={moduleDef.path} className="!text-[var(--color-text-primary)]">
            {moduleDef.shortTitle}
          </Link>
        ),
      })
    }

    for (let i = 1; i < segments.length; i++) {
      result.push({
        key: segments.slice(0, i + 1).join('/'),
        title: <span className="text-[var(--color-text-muted)]">{segments[i]}</span>,
      })
    }

    return result
  }, [location.pathname])

  return <Breadcrumb items={items} className="!text-xs" />
}
